import { SavePreferencesRequest, IUserPreferences, IUserPreferencesService, ClearPreferencesRequest } from "@shared/mirage/services/IUserPreferencesService";
import { BaseApiService } from "./BaseApiService";

export class UserPreferencesService extends BaseApiService implements IUserPreferencesService {
    constructor() {
        super("mirage/userPreferences");
    }
    async getPreferences(): Promise<IUserPreferences | null> {
        const response = await this.httpInstance().get(`/`);
        return response.data;
    }
    async savePreferences(req: SavePreferencesRequest): Promise<void> {
        const response = await this.httpInstance().post(`/savePreferences`, req);
        return response.data;
    }
    async clearPreferences(req: ClearPreferencesRequest): Promise<void> {
        const response = await this.httpInstance().post(`/clearPreferences`, req);
        return response.data;
    }
}
